import React, { Component } from 'react'
import Social from './Social'
import { extend } from '../../../../utils/classes'

export class Header extends Component {
  render() {
    const { parentClass } = this.props
    const headerClass = extend(parentClass, 'header')
    return (
      <div className={headerClass}>
        <span className={extend(headerClass, 'logo')}>Brand</span>
        <Social parentClass={headerClass} />
      </div>
    )
  }
}

export default Header
